// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styl/index.styl'
import '@/assets/iconfont/iconfont.css'
import '@/assets/styl/global.css'
import 'normalize.css'
import Api from './service/api'
import { Popover } from 'element-ui'
import { Person } from './utils/userinfo'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.use(Popover)

Vue.prototype.$request = Api
Vue.config.productionTip = false
Vue.prototype.user = Person
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js